import React from 'react';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';

interface InputDateProps {
	startDate: Date;
	onChange: (date: Date) => void;
	disabled?: boolean;
}

const InputDate = (props: InputDateProps) => {
	const { startDate, onChange, disabled } = props;

	return (
		<div className="flex bg-white border items-center rounded-[3px] my-2 py-2 px-3 w-full">
			<DatePicker
				selected={startDate}
				onChange={(date: Date | null) => {
					if (date) onChange(date);
				}}
				disabled={disabled}
				className="w-full p-0 border-0 z-[99]"
			/>
		</div>
	);
};

export default InputDate;
